import { BudgetPhases } from 'business/constants';
import { REQUESTED_FIELD } from 'routes/BudgetModule/config/constants';
import { PhaseHelpers } from '../phase';

const cadrageConstants = {
    amount: REQUESTED_FIELD,
    comment: undefined as undefined,
    id: undefined as undefined,
    table: undefined as undefined,
    isEditable: false,
    isActive: false,
    isSimulated: false,
    endpoint: undefined as undefined,
    status: undefined as undefined,
    inProgressStatus: undefined as undefined,
    toValidateStatus: undefined as undefined,
    doneStatus: undefined as undefined,
    name: BudgetPhases.CADRAGE,
} as const;

const cadrageHelpers: PhaseHelpers = {
    isInscriptionRejected: () => {
        console.error('Cannot get Reject inscription for cadrage phase');
        return false;
    },
    getPhaseHeaderName: () => '',
} as const;

export const cadragePhase = {
    ...cadrageConstants,
    ...cadrageHelpers,
} as const;
